export const StorageKeys = {
  token: "WINK_APP_TOKEN",
  userContext: "WINK_USER",
  KeepMe: "KeepMe",
  dynamicRegFields: "DYNAMIC_REG_FIELDS",
  resetPasswordToken: 'RESET_TOKEN',
};
